module.exports = __webpack_public_path__ + "static/media/ee77d04c-eb2a-4851-9f3f-473157d07e23.006.ba2d3f23.png";